import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Injectable({
  providedIn: "root"
})
@Pipe({
  name: "highlight",
  standalone: true
})
export class HighlightPipe implements PipeTransform {
  transform(value: string | number, search: string): string {
    const text = typeof value === "number" ? value.toString() : value;

    if (search && text && typeof search === "string") {
      let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      pattern = pattern
        .split(" ")
        .filter((t) => {
          return t.length > 0;
        })
        .join("|");
      const regex = new RegExp(pattern, "gi");
      return text.replace(regex, (match) => `<mark>${match}</mark>`);
    } else if (search && search === text) {
      return `<mark>${value}</mark>`;
    } else {
      return text;
    }
  }
}
